<script>
    import { faEdit, faPen } from "@fortawesome/free-solid-svg-icons";
    import { createEventDispatcher } from "svelte";
    import Fa from "svelte-fa";
    import Button from "../ui/Button.svelte";
    import ClickablePanel from "../ui/ClickablePanel.svelte";
    import EditDevice from "./EditDevice.svelte";
    import RemoveDevice from "./RemoveDevice.svelte";
    import ShowLogin from "./ShowLogin.svelte";

    export let device;

    const dispatch = createEventDispatcher();
    let showCode = false;
    
    let state;
    if (!device.loggedIn) {
        state = "Nicht angemeldet";
    } else {
        const minutesSinceOnline = (Date.now() - device.lastTimeOnline.toDate()) / 1000 / 60;
        if (minutesSinceOnline <= 60) {
            state = "letzte Stunde aktiv";
        } else if (minutesSinceOnline <= 1440) {
            state = "letzte 24h aktiv";
        } else if (minutesSinceOnline <= 10080) {
            state = "letzte Woche aktiv";
        } else if (minutesSinceOnline <= 43200) {
            state = "letzten Monat aktiv";
        } else {
            state = "Über einen Monat inaktiv"
        }
    }
</script>

<ClickablePanel on:open={() => {showCode = true}}>
    <!-- <div class="icon">

    </div> -->
    <div class="icon">
        {#if device.type == "device"}
            📱
        {:else if device.type == "nfc"}
            🏷️
        {/if}
    </div>
    <div class="info">
        <span class="name">
            {device.name}
        </span>
        {#if device.loggedIn}
            <span class="state active">{device.deviceModel} ({state})</span>
        {:else}
            <span class="state inactive">Nicht angemeldet</span>
        {/if}
    </div>
    <div class="actions">
        {#if device.id && device.pw}
            <ShowLogin {device} bind:open={showCode}/>
        {/if}
        <EditDevice {device} on:edit={(e) => dispatch("edit", e.detail)}/>
        <RemoveDevice {device} on:remove={(e) => dispatch("remove", e.detail)}/>
    </div>
</ClickablePanel>

<style>
    .info {
        margin-left: 1rem;
        margin-right: 1rem;
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .state {
        font-size: 0.8rem;
        /* margin: 0.25rem 0; */
    }

    .inactive {
        color: #DA4A2B;
    }
</style>